<app-login-page>
	<h1>Sign in to start your session</h1>

	<form>
		<p-floatlabel variant="on">
			<input
				pInputText
				id="username-input"
				[(ngModel)]="username"
				[ngModelOptions]="{ standalone: true }"
				(ngModelChange)="onUsernameChange()"
				type="email"
				autocomplete="on"
				class="w-full"
				(keyup.enter)="passwordVisible ? login() : continue()"
			/>
			<label for="username-input">Username</label>
		</p-floatlabel>

		@if (passwordVisible) {
			<p-floatlabel variant="on">
				<p-password
					id="password-input"
					inputId="password-input"
					[(ngModel)]="password"
					[ngModelOptions]="{ standalone: true }"
					[feedback]="false"
					[toggleMask]="true"
					class="w-full"
					inputStyleClass="w-full"
					(keyup.enter)="login()"
				/>
				<label for="password-input">Password</label>
			</p-floatlabel>
		}

		@if (notAuthorized) {
			<p-message
				severity="error"
				variant="simple"
			>
				Not authorized
			</p-message>
		}

		@if (loginInProgress) {
			<p-progressbar
				mode="indeterminate"
				[style]="{ height: '6px' }"
			/>
		} @else {
			@if (passwordVisible) {
				<p-button
					label="Sign in"
					id="login-btn"
					styleClass="w-full"
					(onClick)="login()"
				/>
			} @else {
				<p-button
					label="Continue"
					id="continue-btn"
					styleClass="w-full"
					(onClick)="continue()"
				/>
			}
		}
	</form>
</app-login-page>
